export default {
  notes: [],
  isLoadingNotes: false,
  isAddingNote: false,
  addingNoteSuccess: false,
};
